import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id F0028BDF-0589-400F-8596-100CCB029D6E
 * name sort-descending
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-descending.svg
 * tags
 * - Text / Content / Format 
 */
export const SortDescendingIcon = createSvgIcon(<><path d="M19 7H22L18 3L14 7H17V21H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z" /></>, 'SortDescendingIcon');
export default SortDescendingIcon